import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useNavigate } from 'react-router-dom';
// import { useKanban } from '../../hooks/kanban/useKanban';
import { IKanbanColumn, IKanbanLayout } from '../../types/layout/kanban';
import KanbanCard from './card';
import KanbanColumn from './column';

function getColumnClass(index: number) {
    switch (index) {
        case 0:
            return 'm-todo';
        case 1:
            return 'm-dev';
        case 2:
            return 'm-improvement';
        default:
            return '';
    }
}

function Kanban({
    actions, columnsKanban, data,
}: IKanbanLayout) {
    // const { cards } = useKanban(dataLink);
    const navigate = useNavigate();
    const kanbanData = data.ticketKanbanData.data;

    const onEditClick = (cardId: string) => {
        if (typeof actions?.edit === 'string') {
            navigate(`/ticket/view/${cardId}`);
        }
    };

    const renderCards = (column: IKanbanColumn) => {
        let columnCards:any[] = [];

        Object.keys(kanbanData).forEach((key) => {
            if (column.idStatus === key) {
                columnCards = kanbanData[key];
            }
        });

        if (columnCards.length) {
            return columnCards.map((card, index) => (
                <KanbanCard
                    key={card.id}
                    index={index}
                    {...card}
                    onEditClick={typeof actions?.edit === 'string' ? onEditClick : undefined}
                />
            ));
        }

        return (
            <div className="text-center">
                <span>Список пуст</span>
            </div>
        );
    };

    return (
        <DndProvider backend={HTML5Backend}>
            <div className="row kanban">
                {columnsKanban.map((column, index) => (
                    <KanbanColumn key={index} {...column} headerClass={getColumnClass(index)} kanbanActions={actions}>
                        {renderCards(column)}
                    </KanbanColumn>
                ))}
            </div>
        </DndProvider>
    );
}

export default Kanban;
